import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { BasicHeaderComponent } from "./basic-header/basic-header.component";
import { MobileMenuComponent } from "./widgets/mobile-menu/mobile-menu.component";

@Component({
    standalone: true,
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    imports: [CommonModule, BasicHeaderComponent, MobileMenuComponent]
})
export class HeaderComponent {}
